export const strapiUrl = 'https://strapi.obiplus.net';

export const strapiBlogpostUrl = strapiUrl + '/blogposts';